<template>
    <div class="section-bg">
        <div class="header-title">
            <div class="logo-image">
                <img src="/images/logo-mark.svg" alt="ロゴ">
            </div>
            <h1>
                急性期ケア専門士<br/>
                認定登録申し込みフォーム
            </h1>
        </div>
    </div>
</template>

<script>
export default {
    name: "FormHeader"
}
</script>

<style scoped>
.logo-image {
    @apply w-10 lg:w-20 mr-4;
}

.logo-image img {
    @apply w-full;
}
</style>
